import { ReactNode } from 'react';
import styled from 'styled-components';

type StatusBoxProps = {
  headerBackground: string;
  borderColor: string;
  title: ReactNode;
  content: ReactNode;
  className?: string;
  headerColor?: string;
  children?: ReactNode;
};
export const StatusBox = ({
  headerBackground,
  borderColor,
  title,
  content,
  className,
  headerColor,
  children,
}: StatusBoxProps) => {
  return (
    <StyledStatusBox
      borderColor={borderColor}
      headerBackground={headerBackground}
      className={className}
      headerColor={headerColor}
    >
      <div className='header'>{title}</div>
      <div className='content'>{content}</div>
      {children}
    </StyledStatusBox>
  );
};

type StyledStatusBoxProps = {
  borderColor: string;
  headerBackground: string;
  headerColor?: string;
};
const StyledStatusBox = styled.div<StyledStatusBoxProps>`
  display: flex;
  flex-direction: column;

  .header {
    border: 1px solid ${({ borderColor }) => borderColor};
    border-bottom: none;
    background-color: ${({ headerBackground }) => headerBackground};
    padding: 5px 6px 6px;
    text-align: center;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    font-weight: 600;
    color: ${({ headerColor = 'canvastext' }) => headerColor};
  }

  .content {
    padding: 12px 15px 11px;
    border: 1px solid ${({ borderColor }) => borderColor};
    border-top: none;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    flex-grow: 1;

    @media (max-width: 960px) {
      padding: 12px 11px 11px;
    }
  }
`;
